import { fetchIceServer } from '../../store/slices/chat';
import { useState, useEffect, createContext, useContext } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/store';
import { IAccountInfo, selectAccountInfo } from '../../store/slices/auth';
import io from 'socket.io-client';

const SignalingContext = createContext<any>(undefined);

const SignalingContextProvider = ({ children }: any) => {
  const dispatch = useAppDispatch();
  const accountInfo: IAccountInfo = useAppSelector<IAccountInfo>(selectAccountInfo);
  const [roomId, setRoomId] = useState<string>('');
  const userId = accountInfo.external_person_id;

  const { iceServerData } = useAppSelector((state) => state.chat);
  const [socket, setSocket] = useState<any>(null);
  const [onlineUsersInRoom, setOnlineUsersInRoom] = useState<Array<any>>([]);
  const [peerConnection, setPeerConnection] = useState<any>(null);
  const [connectionState, setConnectionState] = useState<any>('');

  // SETUP INITIAL SOCKET
  useEffect(() => {
    dispatch(fetchIceServer());
    const newSocket = io({
      path: '/connect/ws',
      auth: {
        token: process.env.REACT_APP_SIGNALING_SERVER_API_KEY || '',
      },
    });
    setSocket(newSocket);
    return () => {
      newSocket.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Recive and Triger web-socket events
  useEffect(() => {
    if (socket && peerConnection) {
      // Online Users in current RoomId
      socket.on('onlineUsers', (data: any) => {
        console.log('onlineUsers', data);
        setOnlineUsersInRoom(data.online_users.filter((el: any) => el.person_id !== userId));
      });

      // Recive ICE Candidates Offer
      socket.on('receive_candidate_offer', (ice_candidate: any) => {
        console.log('receive_candidate_offer', ice_candidate);
        peerConnection.addIceCandidate(new RTCIceCandidate(ice_candidate));
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socket, peerConnection]);

  const handleIceCandidate = (e: any, calling: boolean) => {
    console.log('calling', calling);
    if (e.candidate) {
      socket.emit(calling ? 'ice_candidate_offer' : 'ice_candidate_answer', {
        room_id: roomId,
        candidate: e.candidate,
      });
    }
  };

  return (
    <SignalingContext.Provider
      value={{
        socket,
        iceServerData,
        handleIceCandidate,
        onlineUsersInRoom,
        setOnlineUsersInRoom,
        peerConnection,
        connectionState,
        setConnectionState: setConnectionState,
        setPeerConnection: setPeerConnection,
        setRoomId,
        roomId,
      }}
    >
      {children}
    </SignalingContext.Provider>
  );
};

export default SignalingContextProvider;

export const useSignalingContext = (): any => {
  const context = useContext(SignalingContext);
  if (!context) {
    throw new Error('Error');
  }
  return context;
};
